// src/data/skills.js

import {
  FaJava,
  FaPython,
  FaGitAlt,
  FaWordpress,
  FaReact,
  FaNodeJs,
  FaMicrosoft,
} from "react-icons/fa";

import {
  SiJavascript,
  SiCplusplus,
  SiMysql,
  SiFirebase,
  SiPostgresql,
  SiDrupal,
  SiClickup,
  SiMoodle,
  SiFlutter,
  SiGoogleadmob,
  SiGoogleplay,
  SiAppstore,
} from "react-icons/si";

import { VscSymbolClass } from "react-icons/vsc";

import {
  MdDesignServices,
  MdPeople,
  MdLightbulb,
  MdSchool,
  MdGroups,
  MdBarChart,
  MdCode,
  MdPhonelinkSetup,
} from "react-icons/md";

import { BsKanban } from "react-icons/bs";
import { TbApi, TbBrandCSharp } from "react-icons/tb";

export const skills = [
  {
    category: "Languages",
    items: [
      { label: "Java", icon: <FaJava /> },
      { label: "Python", icon: <FaPython /> },
      { label: "JavaScript", icon: <SiJavascript /> },
      { label: "C#", icon: <TbBrandCSharp /> },
      { label: "C++", icon: <SiCplusplus /> },
    ],
  },
  {
    category: "Web & Mobile",
    items: [
      { label: "Full-Stack Web", icon: <MdCode /> },
      { label: "Cross-Platform Mobile", icon: <MdPhonelinkSetup /> },
      { label: "React.js", icon: <FaReact /> },
      { label: "Flutter", icon: <SiFlutter /> },
      { label: "Node.js", icon: <FaNodeJs /> },
      { label: "Drupal", icon: <SiDrupal /> },
      { label: "WordPress", icon: <FaWordpress /> },
      { label: "Play Store Publishing", icon: <SiGoogleplay /> },
      { label: "App Store Publishing", icon: <SiAppstore /> },
    ],
  },
  {
    category: "Databases",
    items: [
      { label: "MySQL", icon: <SiMysql /> },
      { label: "PostgreSQL", icon: <SiPostgresql /> },
      { label: "Firebase", icon: <SiFirebase /> },
      { label: "Database Design", icon: <MdDesignServices /> },
    ],
  },
  {
    category: "Tools & Concepts",
    items: [
      { label: "Git", icon: <FaGitAlt /> },
      { label: "OOP", icon: <VscSymbolClass /> },
      { label: "Design Patterns", icon: <MdDesignServices /> },
      { label: "REST APIs", icon: <TbApi /> },
      { label: "AdMob", icon: <SiGoogleadmob /> },
      { label: "Tableau", icon: <MdBarChart /> },
      { label: "ClickUp", icon: <SiClickup /> },
      { label: "SharePoint", icon: <FaMicrosoft /> },
      { label: "Moodle", icon: <SiMoodle /> },
    ],
  },
  {
    category: "Soft Skills",
    items: [
      { label: "Problem Solving", icon: <MdLightbulb /> },
      { label: "Team Collaboration", icon: <MdGroups /> },
      { label: "Communication", icon: <MdPeople /> },
      { label: "Training & Mentoring", icon: <MdSchool /> },
      { label: "Agile / Scrum", icon: <BsKanban /> },
      { label: "Continuous Learning", icon: <MdLightbulb /> },
    ],
  },
];